/* import __COLOCATED_TEMPLATE__ from './link-to.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@tagName('')
export default class SignInLinkTo extends Component {}
